import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleFilter } from '../../../features/task/taskSlice';

const Project = ({name, color}) => {
    const dispatch = useDispatch();
    const {filter} = useSelector(state => state.task)
    return (
        <div className="checkbox-container">
            <input type="checkbox" className={color} checked={filter.includes(name)} onChange={() => dispatch(toggleFilter(name))}/>
            <p className="label">{name}</p>
          </div>
    );
};

export default Project;